// extracted by mini-css-extract-plugin
export default {"container":"swiper_container__eQ+G3","slides":"swiper_slides__NwfCz"};